import React from 'react';

export const WorkerDashboard = () => {
  return (
    <div className="space-y-12">
      <FarmSectionHeader title="My Activity" icon={<Activity className="text-green-700" />} />

      <div className="grid md:grid-cols-2 gap-6">
        <StatCardGlow
          title="My Logs Today"
          value={24}
          unit="entries"
          icon={<Leaf className="h-8 w-8 text-green-600" />}
        />
        <StatCardGlow
          title="Tasks Assigned"
          value={3}
          icon={<Boxes className="h-8 w-8 text-green-600" />}
        />
      </div>

      <FarmSectionHeader title="My Tools" icon={<ArrowRightCircle className="text-green-700" />} />

      <div className="grid md:grid-cols-2 gap-6">
        <ActionCard title="Record Milk" link="/app/production/milk" icon={<Droplets />} />
        <ActionCard title="View My Tasks" link="/app/tasks" icon={<Activity />} />
      </div>
    </div>
  );
};
